// Model.jsx

import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";
import DialogActions from "@mui/material/DialogActions";
import { styled } from "@mui/system";
import { makeStyles } from '@mui/styles';
import {useFormik} from 'formik'
import * as Yup from 'yup'


const useStyles = makeStyles((theme) => ({
  textField: {
    '& .MuiInputBase-root': {
      backgroundColor: 'white', 
      borderRadius:'10px 0px 10px 0px',
      transition: 'background-color 0.3s ease',
      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'red', 
    },
    '&:hover': {
      '& .MuiInputBase-root': {
        backgroundColor: '#D2EAF0', 
        backgroundImage: 'linear-gradient(45deg, #D2EAF0, #33BDE0)', 
        backgroundSize: '200% 100%', 
      },
    },
    '&:focus-within': {
      '& .MuiInputLabel-root': {
        color: 'black', 
        fontWeight:'bold',
        fontSize:'17px'
      },
    },
    '&:focus-without': {
      '& .MuiInputLabel-root': {
        color: 'black', 
        fontSize:'17px'
      },
    },
  },
}));
const useStylesemail = makeStyles((theme) => ({
  textFieldemail: {
    '& .MuiInputBase-root': {
      backgroundColor: 'white', 
      borderRadius:'10px 0px 10px 0px',
      transition: 'background-color 0.3s ease',
      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'red',
    },
    '&:hover': {
      '& .MuiInputBase-root': {
        backgroundColor: '#D2EAF0',
        backgroundImage: 'linear-gradient(45deg, #E9C1EA, #E622EC)',
        backgroundSize: '200% 100%', 
      },
    },
    '&:focus-within': {
      '& .MuiInputLabel-root': {
        color: 'black', 
        fontWeight:'bold',
        fontSize:'17px'
      },
    },
  },
}));
const useStylesNumber = makeStyles((theme) => ({
  textFieldNumber: {
    '& .MuiInputBase-root': {
      backgroundColor: 'white', 
      borderRadius:'10px 0px 10px 0px',
      transition: 'background-color 0.3s ease',
      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'red', 
    },
    '&:hover': {
      '& .MuiInputBase-root': {
        backgroundColor: '#D2EAF0', 
        backgroundImage: 'linear-gradient(45deg, #D4F7CA, #3CF10B)', 
        backgroundSize: '200% 100%', 
      },
    },
    '&:focus-within': {
      '& .MuiInputLabel-root': {
        color: 'black', 
        fontWeight:'bold',
        fontSize:'17px'
      },
    },
  },
}));
const useStylesAddress = makeStyles((theme) => ({
  textFieldAddress: {
    '& .MuiInputBase-root': {
      backgroundColor: 'white', 
      borderRadius:'10px 0px 10px 0px',
      transition: 'background-color 0.3s ease',
      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'red', 
    },
    '&:hover': {
      '& .MuiInputBase-root': {
        backgroundColor: '#D2EAF0',
        backgroundImage: 'linear-gradient(45deg,#C8D2E9, #336AE0)', 
        backgroundSize: '200% 100%', 
      },
    },
    '&:focus-within': {
      '& .MuiInputLabel-root': {
        color: 'black', 
        fontWeight:'bold',
        fontSize:'17px'
      },
    },
  },
}));
const useStylesMessage = makeStyles((theme) => ({
  textFieldMessage: {
    '& .MuiInputBase-root': {
      backgroundColor: 'white', 
      borderRadius:'10px 0px 10px 0px',
      transition: 'background-color 0.3s ease',
      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'red', 
    },
    '&:hover': {
      '& .MuiInputBase-root': {
        backgroundColor: '#D2EAF0',
        backgroundImage: 'linear-gradient(45deg, #EAC1CA, #EA1545)', 
        backgroundSize: '200% 100%', 
      },
    },
    '&:focus-within': {
      '& .MuiInputLabel-root': {
        color: 'black', 
        fontWeight:'bold',
        fontSize:'17px'
      },
    },
  },
}));
const useStylesCancel = makeStyles((theme) => ({
  cancelButton: {
    background: 'linear-gradient(to right,  #f74e2d, #ed0c2e)', 
    transition: 'background 0.3s ease-in-out',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.5)',
    '&:hover': {
      background: 'linear-gradient(to right, #1fa2ff, #12d8fa)', 
    },
  },
}));

const useStylesSubmit = makeStyles((theme) => ({
  cancelSubmit: {
    background: 'linear-gradient(to right, #0F0FF9 ,#051459)', 
    transition: 'background 0.3s ease-in-out',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.5)',
    '&:hover': {
      background: 'linear-gradient(to right, #13F532, #4bfa64)',
    
    },
  },
}));

const CustomDialog = styled(Dialog)`
  .MuiPaper-root {
    background-color: #EDF9FE;
    border-radius: 20px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.9); 
    // background-color: transparent;
    // backdrop-filter: blur(200px);
    // background-color:rgb(82, 141, 217); 
  }
`;


const Model = ({ open, onClose }) => {
  const classes = useStyles();
  const classesemail = useStylesemail();
  const classesNumber = useStylesNumber();
  const classesAddress = useStylesAddress();
  const classesMessage = useStylesMessage();
  const classesCancel = useStylesCancel();
  const classesSubmit = useStylesSubmit();
  const [showPopup, setShowPopup] = useState(false);

  const handleSubmit = () => {
    onClose();
    setShowPopup(true);
  };
  const handleClose = () => {
    setShowPopup(false);
    
  };
  const formik = useFormik({
    initialValues: {
      name: '',
      email: '',
      phone: '',
      address: '',
      message: '',
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .required('*Fill user name*')
        .min(1, '*Minimum 1 character*')
        .max(20, '*Maximum 15 char*'),

      email: Yup.string()
      .required('*Fill user email*')
      .email('*invalid email address*'),


      phone: Yup.string()
      .required('*Fill number*')
      .matches(/^\d+$/, '*Invalid phone number*')
      .min(10, '*Minimum 10 character*')
      .max(12, '*Maximum 12 character*'),

      address: Yup.string()
      .required('*Fill address*'),

      message: Yup.string()
      .required('*Fill message*'),
    }),
    onSubmit: (values) => {
      const { name, email, phone, address, message } = values;
      const whatsappMessage = `Name: ${encodeURIComponent(name)}%0A` +
        `Email: ${encodeURIComponent(email)}%0A` +
        `Phone: ${encodeURIComponent(phone)}%0A` +
        `Address: ${encodeURIComponent(address)}%0A` +
        `Message: ${encodeURIComponent(message)}`;
      const whatsappURL = `https://wa.me/8479089674?text=${whatsappMessage}`;
      window.open(whatsappURL, '_blank').focus();
      setShowPopup(true);
      onClose(); 
      formik.resetForm(); 
    },
  });

  return (
    <div>
      <CustomDialog open={open} onClose={onClose}>
        <DialogTitle sx={{ color: 'black' }}>Contact Form</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            id="name"
            label="Name"
            type="text"
            fullWidth
            className={classes.textField}
            name="name"
            value={formik.values.name}
            onChange={formik.handleChange}
          />
          {formik.touched.name && formik.errors.name ? <em>{formik.errors.name}</em> : null}
          <TextField
            autoFocus
            margin="dense"
            id="email"
            label="Email"
            type="text"
            fullWidth
            className={classes.textField}
            name="email"
            value={formik.values.email}
            onChange={formik.handleChange}
          />
          {formik.touched.email && formik.errors.email ? <em>{formik.errors.email}</em> : null}
          <TextField
            margin="dense"
            id="phone"
            label="Phone"
            type="text"
            fullWidth
            className={classes.textField}
            name="phone"
            value={formik.values.phone}
            onChange={formik.handleChange}
          />
          {formik.touched.phone && formik.errors.phone ? <em>{formik.errors.phone}</em> : null}
          <TextField
            margin="dense"
            id="address"
            label="Address"
            type="text"
            fullWidth
            className={classes.textField}
            name="address"
            value={formik.values.address}
            onChange={formik.handleChange}
          />
          {formik.touched.address && formik.errors.address ? <em>{formik.errors.address}</em> : null}
          <TextField
            margin="dense"
            id="message"
            label="Message"
            multiline
            rows={4}
            fullWidth
            className={classes.textField}
            name="message"
            value={formik.values.message}
            onChange={formik.handleChange}
          />
          {formik.touched.message && formik.errors.message ? <em>{formik.errors.message}</em> : null}
        </DialogContent>
        <DialogActions sx={{ padding: '10px 20px 20px 20px' }}>
        <Button onClick={onClose} variant="contained" className={classesCancel.cancelButton}>Cancel</Button>
        <Button onClick={formik.handleSubmit} variant="contained" className={classesSubmit.cancelSubmit}>Submit</Button>         
        </DialogActions>
      </CustomDialog>
    </div>
  );
};

export default Model;
